<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" persistent scrollable>

      <v-card>

        <v-card-title>
          Cadeaux Physiques
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">

          <v-row align="center" class="bg-light rounded-lg mx-2">
            <v-col cols="6">
              <v-text-field v-model="form.name"
                            outlined
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.name"
                            label="Nom *"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="form.quantity"
                            outlined
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.quantity"
                            label="Quantité *"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="form.percentage"
                            outlined
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.percentage"
                            label="Pourcentage *"
              />
            </v-col>
            <v-col cols="5">
              <v-file-input ref="image"
                            outlined
                            prepend-icon=""
                            prepend-inner-icon="mdi-upload"
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.image"
                            accept="image/png, image/jpeg, image/jpg, .svg"
                            label="Image *"
                            @change="uploadFile"/>
            </v-col>

            <v-col cols="2" class="text-start">
              <v-btn color="gifty" :loading="btnLoading" @click="saveData" dark fab small depressed>
                <v-icon>{{ form.id ? 'mdi-content-save-edit' : 'mdi-check' }}</v-icon>
              </v-btn>
              <v-btn color="gifty" class="ml-1" v-if="form.id" dark icon depressed @click="clear">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>


          <v-row>
            <v-col>
              <v-data-table :headers="headers"
                            :loading="isLoading"
                            class="table-border rounded-lg mt-5"
                            :items="gifts"

              >
                <template v-slot:item.status="{ item }">
                  <v-switch v-model="item.is_active"
                            class="pa-0 ma-0"
                            color="success"
                            hide-details
                            readonly
                            @click="changeStatus(item.id)"></v-switch>

                </template>

                <template v-slot:item.image="{ item }">
                  <v-avatar size="45" rounded class="my-3">
                    <v-img :src="FILE_URL + item.image"></v-img>
                  </v-avatar>
                </template>

                <template v-slot:item.quantity="{ item }">
                  <strong>{{ item.quantity }}</strong>
                </template>

                <template v-slot:item.percentage="{ item }">
                  <strong>{{ item.percentage }} %</strong>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="d-flex align-center">
                    <v-btn icon @click="updateItem(item)">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon
                               v-bind="attrs"
                               v-on="on">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="remove(item.id)">
                          <v-list-item-avatar>
                            <v-icon color="red">mdi-trash-can</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title>Supprimer</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-avatar>
                            <v-icon>mdi-close</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title>Annuler</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>

              </v-data-table>
            </v-col>
          </v-row>


        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      btnLoading: false,
      isLoading: false,
      dialog: false,
      FILE_URL: process.env.VUE_APP_FILE_URL,
      gifts: [],
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Quantité',
          value: 'quantity',
        },
        {
          text: 'Pourcentage',
          value: 'percentage',
        },
        {
          text: 'Image',
          value: 'image',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      formErrors: [],
      form: {},
      id: null,
    };
  },
  methods: {
    open(id) {
      this.id = id
      this.gifts = []
      this.getGifts(id)
      this.form = {
        id: "",
        boosting_method_id: id,
        name: "",
        description: "",
        image: "",
      }

      if (this.$refs.image) {
        this.$refs.image.reset();
      }

      this.dialog = true;
    },
    clear() {
      this.formErrors = {};
      this.form = {
        id: "",
        boosting_method_id: this.id,
        name: "",
        quantity: "",
        percentage: "",
        description: "",
        image: "",
      }

      if (this.$refs.image) {
        this.$refs.image.reset();
      }
    },
    close() {
      this.formErrors = {};
      this.dialog = false;
    },
    uploadFile(file) {
      this.form.image = file
    },
    updateItem(item) {
      this.form = {
        id: item.id,
        boosting_method_id: item.boosting_method_id,
        name: item.name,
        quantity: item.quantity,
        percentage: item.percentage,
        description: item.description,
        image: "",
      }
    },
    getGifts(id) {
      this.isLoading = true;
      HTTP.get("/v1/boosting-methods/gifts", {
        params: {
          boosting_method_id: id
        }
      }).then((res) => {
        this.isLoading = false;
        this.gifts = res.data.data;
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
    saveData() {
      this.formErrors = {};
      this.btnLoading = true;

      const formData = new FormData();
      formData.append("id", this.form.id ?? "");
      formData.append("boosting_method_id", this.form.boosting_method_id);
      formData.append("name", this.form.name);
      formData.append("quantity", this.form.quantity);
      formData.append("percentage", this.form.percentage);
      formData.append("description", this.form.description);

      if (this.form.image) {
        formData.append("image", this.form.image);
      }

      let url = this.form.id ? "/v1/boosting-methods/gifts/update" : "/v1/boosting-methods/gifts/store"

      HTTP.post(url, formData)
          .then(() => {
            this.$successMessage = "Cet élément a été ajouté avec succès";
            this.btnLoading = false;
            this.getGifts(this.form.boosting_method_id);

            if (this.$refs.image) {
              this.$refs.image.reset();
            }

            this.form.id = "";
            this.form.name = "";
            this.form.quantity = "";
            this.form.percentage = "";
            this.form.image = "";

          })
          .catch((err) => {
            this.btnLoading = false;
            this.formErrors = err.response.data.errors;
          });
    },
    remove(id) {
      this.isLoading = true;
      HTTP.post("/v1/boosting-methods/gifts/delete", {
        id: id,
      }).then(() => {
        this.isLoading = false;
        let i = this.gifts.findIndex((el) => el.id === id);
        this.$delete(this.gifts, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.isLoading = true;
      HTTP.post("/v1/boosting-methods/gifts/change-status", {
        id: id,
      }).then(() => {
        this.isLoading = false;
        let index = this.gifts.findIndex(el => el.id === id)
        this.gifts[index].is_active = !this.gifts[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>
</style>
    